module.exports = __webpack_public_path__ + "static/media/default-profile-moose.88261093.jpg";